module.exports = __webpack_public_path__ + "static/img/XMWT01.5d0ed417.jpg";